
/**
 * Custom component for WV Steak House steak items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.2.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-08-29 (1.0.0) (jhoward)
 *      - <biminiSteakItem> copied to <WVSteakHouseSteakItem>.
 *
 *    2024-07-19 (1.0.1) (jhoward)
 *      - Rename .visual_menu--tag CSS rules to .menu--tag in <wv-steak-house-item>.
 *
 *  2025-02-10 (1.1.0) (jhoward)
 *    - Add <menu-schedules> to the <WVSteakHouseSteakItem> component if in admin view.
 *
 *    2025-04-08 (1.2.0) (jhoward)
 *      - Remove "visual_" prefix from class names in <WVSteakHouseSteakItem>.
 *      - Use <menu-item-price> in <WVSteakHouseSteakItem>.
 */

import MenuTag from "../menu-tag.vue";
import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import {computedIsScheduled} from "../../../helpers/menu-sections";
import MenuSchedules from "../schedule/MenuSchedules.vue";
import MenuItemPrice from "./MenuItemPrice.vue";

export default defineComponent({
  name: 'WVSteakHouseSteakItem',
  components: {
    MenuItemPrice,
    MenuSchedules,
    MenuTag
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
  },
  data() {
    return {
      titleRegex: /^\s*(\d+\s?oz)\s(.+)$/
    };
  },
  computed: {
    steakSize(): string {
      const match = this.titleRegex.exec(this.item.mi_title);
      if (match) {
        return match[1];
      }

      return '';
    },
    title(): string {
      const match = this.titleRegex.exec(this.item.mi_title);
      if (match) {
        return match[2];
      }

      return this.item.mi_title;
    },
    isScheduled: computedIsScheduled,
  }
})
